module.exports = __webpack_public_path__ + "static/img/fz2.43197bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz2.png
// module id = FZBA
// module chunks = 0